// extracted by mini-css-extract-plugin
export var actionButton = "_bf-1";
export var actionButtons = "_bf-2";
export var actions = "_bf-0";
export var aiUnread = "_bf-10";
export var alignCenter = "_bf-h";
export var backWrapper = "_bf-3";
export var cellContainer = "_bf-4";
export var checkboxContainer = "_bf-5";
export var contentContainer = "_bf-6";
export var contentHeader = "_bf-8";
export var conversationsTableWrapper = "_bf-s";
export var draftReplyBadgeContainer = "_bf-m";
export var dropdownItem = "_bf-b";
export var dropdownItemsContainer = "_bf-a";
export var dropdownTitle = "_bf-c";
export var errorIcon = "_bf-7";
export var filter = "_bf-d";
export var gray = "_bf-i";
export var headerActionButtons = "_bf-e";
export var headerCheckboxContainer = "_bf-f";
export var icon = "_bf-j";
export var menuContainer = "_bf-k";
export var noMoreTicketsIcon = "_bf-12";
export var noMoreTicketsSubText = "_bf-13";
export var oneLine = "_bf-l";
export var optionsButton = "_bf-n";
export var plus = "_bf-o";
export var portalButtonsWrapper = "_bf-g";
export var red = "_bf-p";
export var scrolledTop = "_bf-9";
export var search = "_bf-q";
export var selectedConversationsCount = "_bf-r";
export var spinner = "_bf-t";
export var strong = "_bf-u";
export var summaryCell = "_bf-v";
export var tableContainer = "_bf-11";
export var tagContainer = "_bf-w";
export var threeDots = "_bf-x";
export var twoLines = "_bf-y";
export var unread = "_bf-z";